<template>
  <div>
    <NuxtPwaManifest />
    <NuxtLayout>
      <NuxtPage />
    </NuxtLayout>
  </div>
  <!-- Nuxt  -->
  <ClientOnly>
    <Toaster closeButton richColors position="top-right" :expand="true" theme="light" />
  </ClientOnly>
</template>
<script lang="ts" setup>
import { Toaster } from '~/components/ui/sonner';
</script>
